import promo1 from "../Components/promotions-slider/promoImages/promo_1.jpeg";
import promo2 from "../Components/promotions-slider/promoImages/promo_2.jpeg";
import promo3 from "../Components/promotions-slider/promoImages/promo_3.jpeg";

/**
 * Акции для слайдера на главной
 * (между стартовым блоком и «Доставка любимых блюд»).
 *
 * Как редактировать:
 * 1. Положите картинку в `src/Components/promotions-slider/promoImages/`.
 * 2. Импортируйте её сверху (как promo1 / promo2 / promo3).
 * 3. Добавьте / измените / удалите объект в массиве `PROMOTIONS`.
 * 4. Порядок в массиве = порядок слайдов.
 * 5. Чтобы скрыть слайдер — оставьте массив пустым: `[]`.
 *
 * Поля:
 * - id     — уникальная строка
 * - image  — импортированная картинка
 * - alt    — описание для доступности (и aria)
 * - accent — цвет рамки/фона: "gold" | "cyan" | "green" | "orange" | "rose"
 * - href   — необязательно (зарезервировано); клик по фото открывает увеличенный попап
 */
export type PromotionAccent = "gold" | "cyan" | "green" | "orange" | "rose";

export type Promotion = {
  id: string;
  image: string;
  alt: string;
  accent?: PromotionAccent;
  href?: string;
};

export const PROMOTIONS: Promotion[] = [
  {
    id: "promo-1",
    image: promo1,
    alt: "Акция американского пула — приведи друга и получи сертификат на игру",
    accent: "cyan",
  },
  {
    id: "promo-2",
    image: promo2,
    alt: "Скоро в клубе: фильмы, PS5, напитки и закуски с друзьями",
    accent: "orange",
  },
  {
    id: "promo-3",
    image: promo3,
    alt: "Романтическое свидание — идеальный вечер для двоих за 3500 ₽",
    accent: "rose",
  },
];

/** Интервал автосмены слайдов (мс). Поставьте 0, чтобы отключить автопрокрутку. */
export const PROMOTIONS_AUTOPLAY_MS = 6500;
